import React, { useState } from "react";
import { useAppTranslation } from "@/utils";
import { useNavigate } from "react-router-dom";
import { Button, Drawer, Flex, Select, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL } from "@/mobile/Settings/Business/utils";
import { isMobileBusinessRegisterURL } from "@/utils/isRegisterURL";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { useImmerAtom } from "jotai-immer";

const MobileEditOfficialSubmited: React.FC = () => {
  const isRegisterURL = isMobileBusinessRegisterURL();
  const { t } = useAppTranslation();
  const [isOfficial, setIsOfficial] = useState(false);
  const navigate = useNavigate();

  const [, setSettingsBusinessState] = useImmerAtom(settingsBusinessAtom);

  function saveToRedux(isOfficialSubmited?: boolean) {
    setSettingsBusinessState((draft) => {
      // eslint-disable-next-line no-param-reassign
      draft.mobileFormEdit.isOfficialSubmited = isOfficialSubmited;
    });

    if (isRegisterURL) {
      if (isOfficialSubmited) {
        return navigate(DashboardRoutes.register.mEditBusiness.officialBusinessName.url);
      }
      return navigate(DashboardRoutes.register.mEditBusiness.officialBusinessDocument.url);
    }

    // none register
    if (isOfficialSubmited) return navigate(DashboardRoutes.settings.mEditBusiness.officialBusinessName.url);

    return navigate(DashboardRoutes.settings.mEditBusiness.officialBusinessDocument.url);
  }

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        size={"100%"}
        title={t("settings.business.businessRegistrationStatus")}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical gap={"middle"}>
          <Typography.Text>{t("settings.business.titleBusinessRegistrationStatus")}</Typography.Text>
          <Select
            placeholder={t("settings.business.selectBusinessType")}
            className={"tw:w-full"}
            onSelect={(selectedValue) => {
              setIsOfficial(selectedValue);
            }}
            options={[
              { label: t("settings.business.unofficial"), value: false },
              { label: t("settings.business.officialRegisteredCompany"), value: true },
            ]}
          />
          <Typography.Text type={"secondary"}>
            <ul>
              <li>{t("settings.business.desOneBusinessRegistrationStatus")}</li>
              <li>{t("settings.business.desTwoBusinessRegistrationStatus")}</li>
            </ul>
          </Typography.Text>
        </Flex>
      </Drawer>

      <EditActionButtons
        onAccept={() => saveToRedux(isOfficial)}
        onCancel={() => saveToRedux(isOfficial)}
        acceptText={isOfficial ? t("next") : undefined}
      />
    </>
  );
};

export default MobileEditOfficialSubmited;
